"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var useCurrentLocationPosition_1 = require("./useCurrentLocationPosition");
var distance_1 = require("../service/distance");
var useSortDealers = function (dealers) {
    var currentPosition = useCurrentLocationPosition_1.default().currentPosition;
    return __spreadArrays(dealers).sort(function (firstDealer, secondDealer) {
        return currentPosition
            ? distance_1.distance.calculateDistance(currentPosition, firstDealer) -
                distance_1.distance.calculateDistance(currentPosition, secondDealer)
            : (firstDealer.label || '').localeCompare(secondDealer.label);
    });
};
exports.default = useSortDealers;
